import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { Link } from 'react-router-dom';
import { useToast } from 'components/Toast/useToast';
import client from 'utils/client';
import { useAuth } from 'contexts/AuthContext';
import TextInput, { PasswordInput } from 'components/FormElements/TextInput';
import './login.css';

const initialValues = { email: '', password: '' };

function Login({ setToken }) {
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState('staff');
  const { onOpen } = useToast();
  const { setUserDetails } = useAuth();

  const handleSubmit = (values) => {
    setLoading(true);
    return client
      .post('/authentication/login', { email: values.email, password: values.password, user_type: userType })
      .then((response) => {
        const { token, ...rest } = response.data.data;
        setUserDetails({ ...rest });
        setToken(response.data.data);
      })
      .catch((error) => {
        onOpen({ type: 'error', message: error?.message || 'Login failed' });
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className='auth-shell'>
      <div className='auth-card'>
        <div className='auth-brand'>
          <span className='auth-brand-mark' aria-hidden='true'>GTI</span>
          <span className='auth-brand-word'>Microfinance</span>
        </div>
        <h1 className='auth-title'>Sign in</h1>
        <p className='auth-subtitle'>Enter your credentials to access the dashboard.</p>

        <div className='role-toggle' role='group' aria-label='Account type'>
          <button
            type='button'
            className={`role-toggle-btn ${userType === 'staff' ? 'is-active' : ''}`}
            onClick={() => setUserType('staff')}>
            Staff
          </button>
          <button
            type='button'
            className={`role-toggle-btn ${userType === 'merchant' ? 'is-active' : ''}`}
            onClick={() => setUserType('merchant')}>
            Merchant
          </button>
        </div>

        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({ isSubmitting }) => (
            <Form className='auth-form'>
              <TextInput className='form-field' name='email' type='email' label='Email' placeholder='you@example.com' autoComplete='email' autoFocus required />
              <PasswordInput className='form-field' name='password' label='Password' placeholder='Enter your password' autoComplete='current-password' required />
              <button type='submit' className='btn-primary auth-submit' disabled={isSubmitting || loading}>
                {isSubmitting || loading ? 'Signing in…' : 'Sign in'}
              </button>
            </Form>
          )}
        </Formik>

        <p className='auth-footer'>
          <Link className='auth-link' to='/request-link'>Trouble signing in?</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
